import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import styles from "./styles.module.scss";
import { Container } from "@components/Container/Container";
import { ImageField } from "@helpers/interfaces/image";
import { UmbracoBackgroundImage } from "@components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage";
import { Heading } from "@components/Heading/Heading";
import { Text } from "@components/Text/Text";
import { Button } from "@components/Button/Button";
import classNames from "classnames";
import { useMediaQuery } from "@react-hook/media-query";
import anime from "animejs";
import downArrow from "@svg-icons/arrow.component.svg";
import { Icon } from "@components/Icon/Icon";

SwiperCore.use([Pagination]);

export interface RangeSliderProps {
  Rates: RangeSlideProps[];
  HelperText: string;
}

export interface RangeSlideProps {
  Key: string;
  Name: string;
  InfoText: string;
  Id: string;
  StartRate: 0.0;
  EndRate: 0.2;
  PromilleCalText: string;
  PromilleCalIcon: ImageField;
  Vehicles: {
    ChosenVehicle: VehicleButtonProps;
    ModalText: string;
  }[];
}



const promilleCal = (vehicle?: Vehicle, rate?: RangeSlideProps) => {

  const PromilleModalContainer = document.getElementById(
    "promilleModalContainer"
  ) as HTMLElement;
  const PromilleModal = document.getElementById(
    "promilleCalModal"
  ) as HTMLElement;
  const PromilleModalText = document.getElementById(
    "modalTextContent"
  ) as HTMLElement;

  const PromilleModalHeadline = document.getElementById(
    "modalHeadlineContent"
  ) as HTMLElement;

  const PromilleModalImage = document.getElementById(
    "modalImageContent"
  ) as HTMLImageElement;

  const PromilleModalClose = document.getElementById(
    "promilleCalModalClose"
  ) as HTMLImageElement;

  const BottomPText = document.getElementById("bottomPText") as HTMLElement;
  const BottomPromilleText = document.getElementById(
    "modalTextContent"
  ) as HTMLElement;




  //If a vehicle has been selected
  if (vehicle) {
    PromilleModal.style.backgroundColor = "#E7E7E6";
    PromilleModal.style.color = "#292f39";
    PromilleModalText.style.color = "#292f39";
    PromilleModalHeadline.style.color = "#292f39";
    PromilleModalHeadline.style.marginBottom = "0px";
    PromilleModalClose.style.color = "#292f39";
    PromilleModalText.innerHTML = vehicle.ModalText;
    PromilleModalHeadline.innerHTML = vehicle.ChosenVehicle.Name;
    BottomPText.innerHTML = "Prøv igen";
    if (vehicle.ChosenVehicle.VehicleImage) {
      PromilleModalImage.src = vehicle.ChosenVehicle.VehicleImage.FullUrl;
    }
  } else {
    if (rate) {
      PromilleModal.style.backgroundColor = "#292f39";
      PromilleModal.style.color = "white";
      PromilleModalText.style.color = "white";
      PromilleModalHeadline.style.color = "white";
      PromilleModalHeadline.style.marginBottom = "40px";
      PromilleModalClose.style.color = "white";
      PromilleModalText.innerHTML = rate.PromilleCalText;
      PromilleModalHeadline.innerHTML = "";
      BottomPText.innerHTML = "Luk";
      BottomPromilleText.style.color = "white";
      if (rate.PromilleCalIcon) {
        PromilleModalImage.src = rate.PromilleCalIcon.FullUrl;
      }
    }
  }


  PromilleModalContainer.style.visibility = "visible";
  // If the opacity of the modal container needs to be calibrated, it can be done via. the last value in the rgba (0, 0, 0, 0,9).
  PromilleModalContainer.style.backgroundColor = "rgba(000, 000, 000, 20%)";
  PromilleModal.style.visibility = "visible";
  PromilleModal.scrollTo(0, 0);
  PromilleModal.style.opacity = "1";
};
const promilleCalClose = () => {
  const PromilleModalContainer = document.getElementById(
    "promilleModalContainer"
  ) as HTMLElement;
  const PromilleModal = document.getElementById(
    "promilleCalModal"
  ) as HTMLElement;
  PromilleModalContainer.style.visibility = "hidden";
  PromilleModalContainer.style.backgroundColor = "rgba(000, 000, 000, 0%)";
  PromilleModal.style.visibility = "hidden";
  PromilleModal.style.opacity = "0";
};




// To disable that annoying "ghost image" whenever someone drags the rateButton, it gets replaced by an invisible img tag.

const RangeSlider: React.FC<RangeSliderProps> = ({ HelperText, Rates }) => {
  const isMobile = useMediaQuery("only screen and (max-width: 1023px)");
  const rateWrapperRef = useRef<HTMLDivElement>(null);
  const rateButtonRef = useRef<HTMLDivElement>(null);
  const swiperRef = useRef<SwiperCore>();

  const [rateState, setRateState] = useState<number>(0);

  const initSwiper = (swiper: SwiperCore) => {
    swiperRef.current = swiper;
  };
  const changeSwiper = (swiper: SwiperCore) => {
    setRateState(swiper.activeIndex);
    PromilleSwitch(swiper.activeIndex, rateState);
  };

  const counts = [8.3333, 24.9999, 41.6665, 58.3333, 75.0, 91.6665];

  const blurEffect =
    globalThis.document &&
    (globalThis.document.querySelector(".sprit-BG") as HTMLElement);
  const blurProcentage = 2; // How much extra blur should be calculated.

  const setBackgroundBlur = (blur: number) => {
    blurEffect.style.filter = `blur(${blur}px)`;
  };

  let dragging = false;

  const handleDragStart = (e: any) => {
    dragging = true;
  };

  const handleDrag = (event: any) => {
    if (dragging) {
      if (rateWrapperRef.current && rateButtonRef.current) {
        const clientX =
          (event.changedTouches && event.changedTouches[0].pageX) ||
          event.pageX;

        let left = Math.round(
          (100 / rateWrapperRef.current.offsetWidth) *
          (clientX - rateWrapperRef.current.offsetLeft)
        );

        if (left < 0) left = 0;
        if (left > 100) left = 100;
        rateButtonRef.current.style.left = left + "%";

        const blurCalc = (counts.length / 100) * left * blurProcentage;
        setBackgroundBlur(blurCalc);
      }
    }
  };

  const handleDragEnd = (event: any) => {
    if (rateWrapperRef.current && rateButtonRef.current) {
      dragging = false;

      const clientX =
        (event.changedTouches && event.changedTouches[0].clientX) ||
        event.clientX;
      let left = Math.round(
        (100 / rateWrapperRef.current.offsetWidth) *
        (clientX - rateWrapperRef.current.offsetLeft)
      );
      if (left < 0) left = 0;
      if (left > 100) left = 100;

      const closest = counts.reduce(function (prev, curr) {
        return Math.abs(curr - left) < Math.abs(prev - left) ? curr : prev;
      });
      const selectedIndex = counts.indexOf(closest);

      anime({
        targets: rateButtonRef.current,
        left: [left, closest],
        duration: 200,
        easing: "easeInOutQuart"
      });
      setRateState(selectedIndex);
      PromilleSwitch(selectedIndex, rateState);

      const blurCalc = (counts.length / 100) * left * blurProcentage;
      setBackgroundBlur(blurCalc);
    }
  };

  const handleDragLeave = (event: any) => {
    if (dragging) {
      handleDragEnd(event);
    }
  };

  const selectRange = (event: any) => {
    if (dragging) return;
    const left =
      rateButtonRef.current?.style.left !== ""
        ? rateButtonRef.current?.style.left
        : counts[0] + "%";
    const goto = counts[event.currentTarget.dataset.index] + "%";

    anime({
      targets: rateButtonRef.current,
      left: [left, goto],
      duration: 200,
      easing: "easeInOutQuart"
    });
    setRateState(parseInt(event.currentTarget.dataset.index));
    PromilleSwitch(parseInt(event.currentTarget.dataset.index), rateState);

  };

  //This function filters the elements to show or hide following the slider's position;
  const PromilleSwitch = (selectedIndex: number, currentIndex: number) => {
    const promilleTexts = document.getElementsByClassName(styles.InfoText);
    const promilleText = promilleTexts[selectedIndex] as HTMLElement;

    for (let i = 0; i < promilleTexts.length; i++) {
      const ElementToHide = () => {
        const promilleText = promilleTexts[i] as HTMLElement;
        anime({
          easing: "easeOutCubic",
          targets: promilleText,
          opacity: 0,
          duration: 300
        });
      };

      const ElementToShow = () => {
        anime({
          easing: "easeOutCubic",
          targets: promilleText,
          translateX: selectedIndex > currentIndex ? [-40, 0] : [40, 0],
          opacity: [0, 1],
          duration: 300
        });

        const duration =
          (selectedIndex > currentIndex
            ? selectedIndex - currentIndex
            : currentIndex - selectedIndex) * 100;

        anime({
          duration: duration,
          easing: "easeInQuart",
          direction: currentIndex < selectedIndex ? "normal" : "reverse",
          update: function (anim) {
            const blurCalc =
              selectedIndex * blurProcentage + anim.progress / 100;
            setBackgroundBlur(blurCalc);
          }
        });
      };

      const elementsCompare = promilleTexts[i] !== promilleText;

      elementsCompare ? ElementToHide() : ElementToShow();
    }
  };


  useEffect(() => {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: 'sprit_og_straf_promille_vist',
      module: 'Sprit og straf',
      item_value: [Rates[rateState].Name]
    });
  }, [Rates[rateState].Name]);



  return (
    <>
      <Heading as="h2" className={styles.choose_permille_title}>
        Vælg promille
      </Heading>
      {globalThis.document && Rates && (
        <>
          {isMobile ? (
            <div key="mobilerates" className={styles.swiperLine}>
              <Swiper
                pagination={{
                  dynamicBullets: true
                }}
                slidesPerView="auto"
                className={styles.swiperContainer}
                onSwiper={swiper => initSwiper(swiper)}
                onSlideChange={swiper => changeSwiper(swiper)}
              >
                {Rates.map((rate: RangeSlideProps, index: number) => {
                  return (
                    <SwiperSlide
                      key={`mobile_${rate.Key}`}
                      className={styles.swiperSlide}
                    >
                      <div
                        className={classNames(
                          "swiper-slide",
                          styles.swiperSlide
                        )}
                      >
                        <div
                          className={classNames(
                            styles.ratingSlide,
                            index === 0 && styles.ratingSlideFirst
                          )}
                          onClick={selectRange}
                          data-index={index}
                        >
                          {index === 0 && (
                            <div
                              className={classNames(
                                styles.ratenumber,
                                styles.ratenumberFirst
                              )}
                            >
                              {rate.StartRate}
                            </div>
                          )}
                          <div className={styles.ratenumber}>
                            {rate.EndRate}
                          </div>
                        </div>
                        <div
                          className={classNames(
                            index === 0 && styles.firstInfoText,
                            styles.InfoText
                          )}
                          id={rate.Id}
                        >
                          <p className={styles.info_percentage}>{rate.Name}</p>
                          <div
                            className={styles.info_paragraph}
                            dangerouslySetInnerHTML={{ __html: rate.InfoText }}
                          ></div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
                <div className={styles.rateButton}>‰</div>
              </Swiper>
            </div>
          ) : (
            <div
              key="desktoprate"
              ref={rateWrapperRef}
              className={classNames("swiper-wrapper", styles.swiperContainer)}
              onMouseMove={handleDrag}
              onTouchMove={handleDrag}
              onMouseUp={handleDragEnd}
              onMouseLeave={handleDragLeave}
              onTouchEnd={handleDragEnd}
            >
              {Rates.map((rate: RangeSlideProps, index: number) => {
                return (
                  <div
                    key={`desktop_${rate.Key}`}
                    className={classNames("swiper-slide", styles.swiperSlide)}
                    onClick={selectRange}
                    data-index={index}
                  >
                    <div
                      className={classNames(
                        styles.ratingSlide,
                        index === 0 && styles.ratingSlideFirst,
                        index === rateState && styles.ratingSlideActive,
                        index === rateState - 1 &&
                        styles.ratingSlideActivePrevious,
                        index === rateState - 1 &&
                        index === 0 &&
                        styles.ratingSlideActivePreviousFirstone
                      )}
                    >
                      {index === 0 && (
                        <div
                          className={classNames(
                            styles.ratenumber,
                            styles.ratenumberFirst
                          )}
                        >
                          {rate.StartRate}
                        </div>
                      )}
                      <div className={styles.ratenumber}>{rate.EndRate}</div>
                    </div>
                    <div
                      className={classNames(
                        index === 0 && styles.firstInfoText,
                        styles.InfoText
                      )}
                      id={rate.Id}
                    >
                      <p className={styles.info_percentage}>{rate.Name}</p>
                      <div
                        className={styles.info_paragraph}
                        dangerouslySetInnerHTML={{ __html: rate.InfoText }}
                      ></div>
                    </div>
                  </div>
                );
              })}

              <div
                id="dragger"
                ref={rateButtonRef}
                className={styles.rateButton}
                onMouseDown={handleDragStart}
                onMouseUp={handleDragEnd}
                onTouchStart={handleDragStart}
              >
                ‰
              </div>
            </div>
          )}

          {<VehiclesButtons {...Rates[rateState]} />}
          <p
            onClick={() => promilleCal(undefined, Rates[rateState])}
            className={styles.promilleCal}
          >
            {HelperText}
          </p>
          <section
            className={styles.promille_modal_container}
            id="promilleModalContainer"
            onClick={promilleCalClose}
          >
            {/* This div has a onClick  applied to it, to entirely ignore the onClick function on the surrounding parent. */}
            <div
              id="promilleCalModal"
              className={styles.promille_modal}
              onClick={promilleCalClose => promilleCalClose.stopPropagation()}
            >
              <div className={styles.modal_crossButton_container}>
                <Heading
                  as="h2"
                  id="promilleCalModalClose"
                  onClick={promilleCalClose}
                >
                  &#x2715;
                </Heading>
              </div>
              <div className={styles.promille_content_container}>
                <div className={styles.modal_icon}>
                  <img alt="" id="modalImageContent" />
                </div>
                <Heading
                  className={styles.modal_title}
                  as="h2"
                  id="modalHeadlineContent"
                ></Heading>
                <div
                  id="modalTextContent"
                  className={styles.modal_text_container}
                ></div>
                <div className={styles.modal_retryButton_container}>
                  <Button onClick={promilleCalClose} data-tracking="alcohol-try-again-button">
                    <p id="bottomPText"></p>
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export interface VehicleButtonProps {
  Key: string;
  Name: string;
  Vehicle: string;
  VehicleImage: ImageField;
}

export interface VehicleButtonsProps {
  Vehicles: VehicleButtonProps[];
}

export interface Vehicle {
  ChosenVehicle: VehicleButtonProps;
  ModalText: string;
  Key: string;
}

const VehiclesButtons: React.FC<RangeSlideProps> = props => {
  const isMobile = useMediaQuery("only screen and (max-width: 1023px)");

  return (
    <>
      <Heading as="h2" className={styles.choose_vehicle_title}>
        Vælg køretøj
      </Heading>
      {globalThis.document && props && (
        <>
          {isMobile ? (
            <Swiper
              centeredSlides
              slidesPerView={"auto"}
              className={styles.vehicle_wrapper_mobile}
            >
              {props.Vehicles.map((vehicle: Vehicle) => {
                return (
                  <SwiperSlide
                    className={styles.swiperslide}
                    key={`mobile_${vehicle.Key}`}
                  >
                    <Button onClick={() => promilleCal(vehicle, undefined)} data-tracking="alcohol-vehicle-button">
                      {vehicle.ChosenVehicle.Name}
                    </Button>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <div className={styles.vehicle_wrapper}>
              {props.Vehicles.map((vehicle: Vehicle) => {
                return (
                  <div key={`desktop_${vehicle.Key}`}>
                    <Button onClick={() => promilleCal(vehicle, undefined)} data-tracking="alcohol-vehicle-button">
                      {vehicle.ChosenVehicle.Name}
                    </Button>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </>
  );
};

export interface SpritProps {
  HeroTitle: string;
  HeroDescription: string;
  HeroImage: ImageField;
  Rates: RangeSlideProps[];
  PromilleHelperText: string;
}

const Sprit: React.FC<SpritProps> = ({
  HeroTitle,
  HeroDescription,
  HeroImage,
  Rates,
  PromilleHelperText
}) => {
  const jumpPoint = useRef<HTMLDivElement | null>(null);
  const executeScroll = () =>
    jumpPoint.current && jumpPoint.current.scrollIntoView();

  return (
    <>
      <section className={styles.spirit_campaign_container}>
        <div className={styles.background_image_container}>
          <UmbracoBackgroundImage
            image={HeroImage}
            width={[350, 768, 1200, 2000]}
            className={[styles.spirit_background_image, "sprit-BG"].join(" ")}
          ></UmbracoBackgroundImage>
        </div>
        <Container className={styles.spirit_content_container}>
          {HeroTitle && (
            <Heading as="h1" className={styles.spirit_content_title}>
              {HeroTitle}
            </Heading>
          )}
          {HeroDescription && (
            <Text className={styles.spirit_content_description}>
              {HeroDescription}
            </Text>
          )}
          {Rates && (
            <RangeSlider Rates={Rates} HelperText={PromilleHelperText} />
          )}
        </Container>
      </section>
      <div className={styles.arrow_button_container} ref={jumpPoint}>
        <Button onClick={executeScroll}>
          <Icon svg={downArrow} className={styles.arrow_button_icon} />
        </Button>
      </div>
    </>
  );
};
export { Sprit };